import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClinicDocument } from '../../domain/models/clinic-document.model';
import { IDocumentationRepository } from '../../domain/repositories/documentation.repository';
import { DocumentationRemoteDatasource } from '../datasources/remote/documentation.remote-datasource';
import { DocumentationMapper } from '../mappers/documentation.mapper';

@Injectable()
export class DocumentationRepositoryImpl implements IDocumentationRepository {
  private readonly datasource = inject(DocumentationRemoteDatasource);
  private readonly mapper = inject(DocumentationMapper);

  public getCatalogue(): Observable<readonly ClinicDocument[]> {
    return this.datasource.getCatalogue().pipe(map((dtos) => this.mapper.toDocuments(dtos)));
  }

  public getContent(documentId: string): Observable<Blob> {
    return this.datasource.getContent(documentId);
  }
}
